// @ts-check
import BaseAbility from './base-ability';
import { variation } from 'ember-launch-darkly';
export default class extends BaseAbility {
  get canList() {
    const featureFlagEnabled =
      variation('hcp-ui-infragraph-access') ||
      localStorage.getItem('hcp-ui-infragraph-access') === 'true';
    return featureFlagEnabled;
  }
}
